var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":"auto","viewBox":"0 0 10 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 5.5L0 0.5H10L5 5.5Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }